import { DepositSidebar } from 'components';
import React from 'react';

interface Props {
  isPro?: boolean;
  big?: boolean;
}

export const DepositPageContainer: React.FC<Props> = ({ isPro = false, big = false, children }) => {
  return isPro ? (
    <>
      <div className={`container-left container-left-large-big`}>{children}</div>
      <div className="container-right">
        <DepositSidebar />
      </div>
    </>
  ) : (
    <div className={`container-solo${big ? '-big' : ''}`}>{children}</div>
  );
};
